<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr" @remoteMethod="remoteMetd"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView_CheckVouch">
			<div class="BottomTable">
				<CommonbtnUpLoad v-if="auth.includes('add')" backgroundColor="#FFF" title="导入" fontSize="14px"
					@getFile="handImport" :src="require('@/assets/icon/icon-drjys.png')" />
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
					:src="require('@/assets/icon/daoc.png')" />
				<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
					@click="handDownload">下载模版</a>
			</div>
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData" style="width: 100%;">
					<el-table-column prop="InvAddCode" label="产品型号" />
					<el-table-column prop="InvName" label="产品名称" />
					<el-table-column prop="InvClassName" label="产品线" />
					<el-table-column prop="Quantity" label="库存数量" />
					<el-table-column prop="InvUniqueCode" label="唯一码" />
					<el-table-column prop="PosCode" label="寄售库位" />
					<el-table-column prop="CreateTime" label="上报时间" />
				</el-table>
			</div>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import Commontable from '../../../../components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import utils from '../../../../common/utils'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import {
		DownStockByCustomer,
		GetOrderCustomer,
		GetStockByCustomerList,
		ExportStockByCustomer,
		ImportStockByCustomer
	} from '@/api/newsapi'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			CommonbtnUpLoad,
			Commontable,
			DialogFrom,
			Commondropdownlist
		},
		computed: {
			cusCode() {
				return this.$store.state.MenusData.CusCode;
			}
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				FromArr: [],
				tableData: [],
				dialogVisible: false,
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.InventoryClassList();
			if (this.cusCode) {
				this.getData();
				this.FromArr.splice(4, 1);
			} else {
				this.getOrderCustomer();
			}
		},
		methods: {
			//查询列表数据
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.Inventory = this.FromArr[0].modelvalue;
				this.query.InvClass = this.FromArr[1].modelvalue;
				this.query.InvUniqueCode = this.FromArr[2].modelvalue;
				this.query.Batch = this.FromArr[3].modelvalue;
				if (this.FromArr.length == 5) {
					this.query.CusCode = this.FromArr[4].modelvalue;
				}
				let {
					code,
					data,
					message
				} = await GetStockByCustomerList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
					loading.close();
				} else {
					loading.close();
					this.$message.error(message);
				}
			},
			// 产品线下拉
			async InventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.FromArr[1].options = []
					data.data.map((item, index) => {
						this.FromArr[1].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			// 经销商下拉
			async getOrderCustomer(CusName = '') {
				let {
					code,
					data
				} = await GetOrderCustomer({
					CusName: CusName
				});
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						this.FromArr[4].options.push({
							label: item.CusName,
							value: item.CusCode,
						})
					})
				}
			},
			//下载模板
			async handDownload() {
				let {
					data,
					code,
					message
				} = await DownStockByCustomer({})
				if (code == 0) {
					window.location.href = data
				} else {
					this.$message.error(message);
				}
			},
			//导入数据
			async handImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await ImportStockByCustomer(formdata);
				if (code == 0) {
					this.$message.success('导入成功');
					this.handSearch();
				} else {
					if (data && data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			async handExport(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.Inventory = this.FromArr[0].modelvalue;
				this.query.InvClass = this.FromArr[1].modelvalue;
				this.query.InvUniqueCode = this.FromArr[2].modelvalue;
				this.query.Batch = this.FromArr[3].modelvalue;
				if (this.FromArr.length == 5) {
					this.query.CusCode = this.FromArr[4].modelvalue;
				}
				let resexprot = await ExportStockByCustomer(this.query)
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `唯一码库存上报${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			//顶部经销商搜索
			remoteMetd(e) {
				this.getOrderCustomer(e.qurey);
			}
		},
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 120px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			//bottom: 21px;
		}
	}

	.ContentView_CheckVouch {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 0px;
		}

		.ativte {
			border: 1px solid red;
			color: #e71d43;
			background-color: #fce8ec;
			transition: 0.2s linear;
		}

		.incenters {
			padding: 14px 4px;

			div {
				margin-left: 8px;
				margin-right: 8px;
				margin-top: 5px;
				margin-bottom: 5px;
				// width: 100%;
			}
		}

		.topstate {
			width: 100px;
			height: 32px;
			font-size: 14px;
			border: 1px solid #e6e6e6;
			line-height: 32px;
			text-align: center;
			cursor: pointer;
			display: inline-block;
			user-select: none;
		}

		.custom-table {
			padding: 0px 0px 24px 0px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;

				.cell {
					.update_ipt {
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border-radius: 0px;
						}

						.el-input__inner:focus {
							border-color: #e71d43;
						}
					}

					.table-export {
						color: #e71d43;
						cursor: pointer;
					}
				}
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}

			// /deep/.el-table__body {
			// 	td {
			// 		padding: 0px 0 !important;
			// 		cursor: pointer;
			// 	}
			// }
		}

	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}
</style>